import { Injectable } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { GameApi } from 'src/app/shared/apis/game.api';
import {
  Config,
  IHeaderMenus,
  ILeftMenus,
  InfoExpandList,
  InfoVerticallyList,
  LabelScenesRedirectMethodEnum,
  NewTags,
} from 'src/app/shared/interfaces/game.interface';
import { cacheValue } from 'src/app/shared/service/general.service';
import { LocaleService } from 'src/app/shared/service/locale.service';
import { ToastService } from 'src/app/shared/service/toast.service';
@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class LeftMenuService {
  constructor(
    private localeService: LocaleService,
    private toast: ToastService,
    private gameApi: GameApi,
  ) {}

  /** 全局标签订阅 */
  private getNewTags$!: Observable<NewTags | null>; // 所有标签缓存

  /** 弹窗展示 */
  popupStatus: boolean = false;

  /**
   * 请求标签
   *
   * @returns
   */
  onGetTags() {
    return (
      this.getNewTags$ ??
      ((this.getNewTags$ = this.gameApi.getScenesData().pipe(
        cacheValue(1000 * 60 * 10), //缓存10分钟
        map(data => (data && this.newObj(data)) || {}),
        shareReplay(1),
      )),
      this.getNewTags$)
    );
  }

  private newObj(v: unknown) {
    return JSON.parse(JSON.stringify(v));
  }

  /**
   * 路由拼接
   *
   * @param menu
   * @returns
   */
  getLinkByMethod(
    menu:
      | IHeaderMenus
      | ILeftMenus
      | InfoExpandList
      | InfoVerticallyList
      | {
          redirectMethod: string;
          config: Config;
          labelId?: string;
          providerSetting?: { secondaryPage: boolean; gameOpenMethod: string | null } | null;
          gameSetting?: { isFullScreen: boolean };
        },
  ) {
    const concatUrl = (value: string | undefined): string => {
      if (!value) return '';
      if (value.startsWith('/')) {
        return value
          .split('/')
          .filter(v => v)
          .join('/');
      }
      return value;
    };

    switch (menu.redirectMethod) {
      //标签页
      case LabelScenesRedirectMethodEnum[0]:
        return `casino/category/` + concatUrl(menu.labelId!.toString());
      //指定URL
      case LabelScenesRedirectMethodEnum[1]:
        return concatUrl(menu.config?.assignUrl);
      // 选择下拉并且配置url
      case LabelScenesRedirectMethodEnum[2]:
        return concatUrl(menu.config?.assignDropDownListUrl);
      //指定厂商
      case LabelScenesRedirectMethodEnum[3]:
        let url: string = '';
        if (menu?.providerSetting?.secondaryPage) {
          url = `casino/provider/` + concatUrl(menu.config?.assignProviderId);
        } else {
          url = `play/` + concatUrl(menu.config?.assignProviderId);
        }
        return url;
      //指定游戏
      case LabelScenesRedirectMethodEnum[4]:
        let gameUrl: string = '';
        if (menu?.gameSetting?.isFullScreen) {
          gameUrl = `play/${concatUrl(menu.config?.assignGameProviderId)}/${menu.config?.assignGameCode}`;
        } else {
          gameUrl = `casino/games/${concatUrl(`${menu.config?.assignGameProviderId}/${menu.config?.assignGameCode}`)}`;
        }
        return gameUrl;
      default:
        return '';
    }
  }

  /** 最喜欢 */
  enableFavorites = {
    name: this.localeService.getValue('bookmark'),
    ident: 'casino-favorites',
    page: this.getLinkByMethod({
      redirectMethod: 'DropDownList',
      config: { assignDropDownListUrl: 'favorites' },
    }),
    icon: 'icon-heart',
    needLogined: true,
    closeOnclick: true,
  };

  /** 最新玩过 */
  enableRecentlyPlayed = {
    name: this.localeService.getValue('recently'),
    ident: 'casino-history',
    page: this.getLinkByMethod({
      redirectMethod: 'DropDownList',
      config: { assignDropDownListUrl: 'recentPlayed' },
    }),
    icon: 'icon-clock-full',
    needLogined: true,
    closeOnclick: true,
  };

  DEFAULT_MENU: any = {
    home: {
      name: this.localeService.getValue('home'),
      ident: 'home',
      page: this.getLinkByMethod({ redirectMethod: 'DropDownList', config: { assignDropDownListUrl: '' } }),
      icon: 'icon-home',
      showOnH5: true,
      showOnWeb: false,
      closeOnclick: true,
    },
    list: [],
    top: [this.enableFavorites, this.enableRecentlyPlayed],
    promotion: {
      name: this.localeService.getValue('new_coupon'),
      ident: 'latest-offers',
      page: this.getLinkByMethod({
        redirectMethod: 'DropDownList',
        config: { assignDropDownListUrl: 'promotions/offer' },
      }),
      icon: 'icon-menu-promotion',
      webIcon: 'icon-menu-promotion',
      closeOnclick: true,
      expand: false,
    },
    options: [
      {
        name: `VIP-${this.localeService.getValue('club')}`,
        ident: 'vip-club',
        page: this.getLinkByMethod({
          redirectMethod: 'DropDownList',
          config: { assignDropDownListUrl: 'member/center/vip-level' },
        }),
        icon: 'icon-vip-club',
        webIcon: 'icon-vip-club',
        closeOnclick: true,
        expand: false,
      },
      // 联盟暂时不做
      // {
      //   name: this.localeService.getValue('agent_p'),
      //   ident: 'affliate',
      //   page: null,
      //   // page: 'member/center/share/home',
      //   icon: 'icon-affiliate',
      //   webIcon: 'icon-affiliate',
      //   closeOnclick: true,
      //   expand: false,
      //   waiting: true,
      // },
      // {
      //   name: this.localeService.getValue('fair_game'),
      //   ident: 'fair-game',
      //   page: null,
      //   icon: 'icon-fair-game',
      //   webIcon: 'icon-fair-game',
      //   closeOnclick: true,
      //   expand: false,
      //   waiting: true,
      // },
    ],
    referralId: [
      {
        name: this.localeService.getValue('ref_id'),
        showOnRail: true,
        ident: 'referralId', //请勿修改
        page: this.getLinkByMethod({ redirectMethod: 'DropDownList', config: { assignDropDownListUrl: 'Null' } }),
        image: 'assets/temp5/recommend-friend/gift.png',
        expand: false,
      },
    ],
    supports: [
      //赞助先不做
      // {
      //   name: this.localeService.getValue('sponsorship'),
      //   ident: 'sponsorship', //请勿修改
      //   page: '',
      //   icon: 'icon-sponsorship',
      //   expand: false,
      //   waiting: true,
      // },
      {
        name: this.localeService.getValue('online_cs'),
        ident: 'onLines', //请勿修改
        icon: 'icon-service-online',
        expand: false,
      },
      {
        name: this.localeService.getValue('chat'),
        ident: 'chat', //请勿修改
        icon: 'icon-chat-vip',
        needLogined: true,
        expand: false,
      },
    ],
    systems: [
      // 默认语言语言选择
      {
        name: '',
        ident: 'langSelect', //请勿修改
        icon: null,
        showOnRail: true,
      },
      // 默认货币
      {
        name: 'None',
        ident: 'conversionCurrency', //请勿修改
        icon: null,
        showOnRail: true,
      },
      //日夜间版
      {
        name: '',
        ident: 'themeSelect', //请勿修改
        icon: 'icon-sun',
        showOnRail: true,
      },
    ],
  };

  commingSoon() {
    this.toast.show({
      message: `${this.localeService.getValue('comming')}, ${this.localeService.getValue('waiting')}`,
      title: this.localeService.getValue('hint'),
      type: 'fail',
    });
  }
}
